import { useApolloClient } from "@apollo/client";
import { useEffect } from "react";

export const INVENTORY_REFRESH_INTERVAL = 15000;

interface RefreshQuery {
  startPolling: (interval: number) => void;
  stopPolling: () => void;
  refetch: () => Promise<unknown>;
}

export function useVisiblePolling(
  { startPolling, stopPolling, refetch }: RefreshQuery,
  enabled = true
) {
  const client = useApolloClient();
  useEffect(() => {
    if (!enabled) return;

    const updateVisibility = () => {
      stopPolling();
      if (!document.hidden) {
        // The query owns loading/error state, including failed refreshes.
        void refetch().catch(() => undefined);
        startPolling(INVENTORY_REFRESH_INTERVAL);
      }
    };

    if (!document.hidden) startPolling(INVENTORY_REFRESH_INTERVAL);
    document.addEventListener("visibilitychange", updateVisibility);
    window.addEventListener("focus", updateVisibility);
    return () => {
      stopPolling();
      document.removeEventListener("visibilitychange", updateVisibility);
      window.removeEventListener("focus", updateVisibility);
    };
  }, [client, enabled, startPolling, stopPolling, refetch]);
}
